import script from "./DayPickerPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./DayPickerPopup.vue?vue&type=script&setup=true&lang=js"

import "./DayPickerPopup.vue?vue&type=style&index=0&id=0a90dc0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a90dc0e"]])

export default __exports__